import React, { useEffect, useState } from 'react';
import './activeLists.scss';
import { Tabs, Table, Avatar, Button, Tag, Space, Row, Col, Input, Modal, List } from 'antd';
import { PlusOutlined, EyeOutlined, SearchOutlined, CloseOutlined, ExclamationCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { appDispatch, RootState } from '../../../app/store';
import { fetchONRoles, fetchONUserDetails, fetchRequestLists, resetFetchONSpecialities } from '../../../features/superAdmin/requestLIsts/requestListsSlice';
import { toast } from 'react-toastify';
import { Skeleton, Card } from 'antd';
import { UserDetailsModal } from '../requestLists/components/userDetailsModal/UserDetailsModal';
import { DEFAULT_PROFILE_IMAGE, SUPER_ADMIN_API_URL } from '../../../constants';
import SimpleButton from '../../../components/buttons/simpleButton/SimpleButton';
import { LiaSearchSolid } from 'react-icons/lia';
import { deleteMembers, fetchDeletedMembersList, fetchMembersList, fetchNonMembersList, filterMembers } from '../../../features/members/membersSlice';
import { deleteAccounts, fetchActiveAccountsList, fetchDeletedAccountsList, fetchInactiveAccountsList } from '../../../features/accounts/accountsSlice';
import dayjs from 'dayjs';
import NonMemberListAction from '../memberManagement/nonMemberListAction';
import ActiveListAction from './activeListAction';
import { fetchNotesList } from '../../../features/users/usersSlice';


interface UserData {
  key: string;
  name: string;
  email: string;
  status: string;
  avatar: string;
}

export const ActiveList = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch<appDispatch>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [activeTab, setActiveTab] = useState<string>('active');
  const [searchquery, setSearchquery] = useState<string>("");

  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedSpeciality, setSelectedSpeciality] = useState("");
  const [selectedSite, setSelectedSite] = useState("");
  const [selectedActive, setSelectedActive] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [licenseNumbers, setLicenseNumbers] = useState<string[]>([]);
  const [updatedData, setUpdatedData] = useState<any[]>([]);
  const [isUserDetailModalVisible, setIsUserDetailModalVisible] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState<React.Key[]>([]);
  const [loadingUserId, setLoadingUserId] = useState<any>(null);
  const {
    userDetailsData,
    isLoading: isUserDetailsLoading,
  } = useSelector((state: RootState) => state.requestLsts.fetchONUserDetails);
  const activeAccountsList = useSelector((state: RootState) => state.accounts.fetchActiveAccountsList.fetchActiveAccountsListData);
  const inactiveAccountsList = useSelector((state: RootState) => state.accounts.fetchInactiveAccountsList.fetchInactiveAccountsListData);
  const deletedAccountsList = useSelector((state: RootState) => state.accounts.fetchDeletedAccountsList.fetchDeletedAccountsListData);
  const { confirm } = Modal;


  const handleShowLicenses = (numbers: string[]) => {
    setLicenseNumbers(numbers);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setLicenseNumbers([]);
  };

  const {
    fetchNonMembersListData,
    isLoading,
    totalCount
  } = useSelector((state: RootState) => state.members.fetchNonMembersList);

  // useEffect(() => {
  //   setUpdatedData(updatedData)
  // }, [updatedData])

  useEffect(() => {
    console.log("test ac activeAccountsList",activeAccountsList)
    if (activeTab === "active") {
      setUpdatedData(activeAccountsList || []);
    } else if (activeTab === "inactive") {
      setUpdatedData(inactiveAccountsList || []);
    } else if (activeTab === "deleted") {
      setUpdatedData(deletedAccountsList || []);
    }
  }, [activeTab, activeAccountsList, inactiveAccountsList, deletedAccountsList]);

  useEffect(() => {
    const currentTab = TABS.find(tab => tab.key === activeTab);
    const thunkArgs = { searchquery: searchquery || "", pageNumber: 1 };

    if (currentTab?.key === 'active') {
      dispatch(fetchNonMembersList(thunkArgs));
    } else if (currentTab?.key === 'inactive') {
      dispatch(fetchMembersList(thunkArgs));
    } else if (currentTab?.key === 'deleted') {
      dispatch(fetchDeletedMembersList(thunkArgs));
    }
  }, [activeTab]);
// console.log(selectedRowId,"selectedRowId")
  useEffect(() => {
    const thunkArgs = {
      searchquery: searchquery || "",
      pageNumber: 1,

    }

    dispatch(fetchActiveAccountsList(thunkArgs));
    dispatch(fetchInactiveAccountsList(thunkArgs));
    dispatch(fetchDeletedAccountsList(thunkArgs));
    // dispatch(fetchONRoles({}))

  }, [dispatch]);

  const handleDeleteUser = () => {
    confirm({
      title: "Delete confirmation",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you want to delete?",
      centered: true,
      onOk() {
        const payload = {
          is_on_user_delete: true,
          is_on_account_delete: true,
          on_user_ids: selectedRowIds

        };
        dispatch(deleteAccounts(payload))
          .then((data) => {
            if (data.payload.isSuccess) {
              toast.success(data.payload.message);
              resetTableSelection();
              setTimeout(() => {
                dispatch(fetchActiveAccountsList({ searchquery, pageNumber })); // refresh
                dispatch(fetchInactiveAccountsList({ searchquery, pageNumber })); // refresh
                dispatch(fetchDeletedAccountsList({ searchquery, pageNumber })); // refresh
              }, 500)


            } else {
              toast.error(data.payload);
            }
          })
          .catch((error) => {
            console.error("Delete failed:", error);
          });
      },
      onCancel() { },
    });
  };


  const handleSearch = () => {
    const params = {
      searchquery: searchquery ? searchquery : ""
    }
    if (activeTab === "active") {
      dispatch(fetchActiveAccountsList(params));

    }
    else if (activeTab === "inactive") {
      dispatch(fetchInactiveAccountsList(params));

    }
    else if (activeTab === "deleted") {
      dispatch(fetchDeletedAccountsList(params));

    }
  }


  // Table row selection config
const rowSelection = {
  selectedRowKeys: selectedRowIds,  // ✅ directly use state
  onChange: (_selectedRowKeys: React.Key[], selectedRowsData: any[]) => {
    setSelectedRowIds(_selectedRowKeys); // ✅ keep keys in sync
    setSelectedRows(selectedRowsData);
  },
};

  // Each of these used to re-dispatch the *unfiltered* member lists (and the
  // member lists at that, not the account lists this screen shows). The effect
  // above then copied that unfiltered list back into `updatedData`, wiping any
  // result the Apply button had just produced -- so picking a specialty, site,
  // role or status visibly did nothing. Selecting only records the choice now;
  // ActiveListAction's Apply runs the real filter call and hands the rows back
  // through onFilterResults.
  const handleSpecialityChange = (val: string) => {
    setSelectedSpeciality(val);
  };

  const handleSiteChange = (val: string) => {
    setSelectedSite(val);
  };

  const handleActiveChange = (val: string) => {
    setSelectedActive(val);
  };

  const handleRoleChange = (val: string) => {
    setSelectedRole(val);
  };

  const handleClearAll = () => {
    // setSelectedSpeciality("");
    // setSelectedRole("");
    // dispatch(filterMembers({}))
    // dispatch(fetchNonMembersList(thunkArgs));
    // dispatch(fetchMembersList(thunkArgs));
    // dispatch(fetchDeletedMembersList(thunkArgs));
      const activeThunkArgs = {
        searchquery: searchquery || "",
        pageNumber: 1,

      }
      dispatch(fetchActiveAccountsList(activeThunkArgs));

      const inActiveThunkArgs = {
        searchquery: searchquery || "",
        pageNumber: 1,

      }
      dispatch(fetchInactiveAccountsList(inActiveThunkArgs));
      const deletedThunkArgs = {
        searchquery: searchquery || "",
        pageNumber: 1,

      }
      dispatch(fetchDeletedAccountsList(deletedThunkArgs));

  };

  const resetTableSelection = () => {
    setSelectedRows([]);
  };

  const handleEditUserRequest = (user: any) => {
    // setSelectedUser(user);
    // setIsModalVisible(true);
    navigate("/superadmin/account-lists/edit-user", {
      state: {
        isEditMode: true,
        userId: user?.id
      }
    })
  }

  const TABS = [
    { label: 'Active Accounts', key: 'active', status: 'activeAccounts' },
    { label: 'Inactive Accounts', key: 'inactive', status: 'inactiveAccounts' },
    { label: 'Deleted Accounts', key: 'deleted', status: 'deletedAccounts' },
  ];

  useEffect(() => {
    const currentTab = TABS.find(tab => tab.key === activeTab);
    if (currentTab?.key === 'active') {
      const thunkArgs = {
        searchquery: searchquery || "",
        pageNumber: 1,

      }
      dispatch(fetchActiveAccountsList(thunkArgs));

    } else if (currentTab?.key === 'inactive') {
      const thunkArgs = {
        searchquery: searchquery || "",
        pageNumber: 1,

      }
      dispatch(fetchInactiveAccountsList(thunkArgs));

    } else if (currentTab?.key === 'deleted') {
      const thunkArgs = {
        searchquery: searchquery || "",
        pageNumber: 1,

      }
      dispatch(fetchDeletedAccountsList(thunkArgs));
    }
  }, [activeTab])


  const handleTabChange = (key: string) => {
    setActiveTab(key);
    setPageNumber(1);

    handleClearAll()
  };

  const handlePageChange = (page: number) => {
    setPageNumber(page);
  };

  const handleViewDetails = async (user: any) => {
    setLoadingUserId(user?.id);
    try {
      await dispatch(fetchNotesList({ id: user?.id }));
      const response = await dispatch(fetchONUserDetails(user?.id))
      if (response?.payload?.isSuccess) {
        setSelectedUser(user);
        setIsUserDetailModalVisible(true);
      }
    } finally {
      setLoadingUserId(null);
    }
  };

  const handleModalClose = () => {
    setIsUserDetailModalVisible(false);
    setSelectedUser(null);
  };


  const activeAccountsColumns = [
    {
      title: 'Display Name',
      dataIndex: 'display_name',
      key: 'display_name',

      render: (_: any, record: any) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Avatar size={32} src={record.profile_pic ?? DEFAULT_PROFILE_IMAGE} alt={record.display_name} />
          <div>
            <div style={{ fontWeight: 500, fontSize: 13 }}>{record.display_name}</div>
          </div>
        </div>
      ),
    },
    {

      title: 'Medical License Number',
      dataIndex: 'license_numbers',
      key: 'license_numbers',
      render: (numbers: string[]) => {

        // Handle no data
        if (!Array.isArray(numbers) || numbers.length === 0) {
          return 'N / A';
        }

        // Style object for license "pill"
        const pillStyle: React.CSSProperties = {

          padding: '4px 8px',
          borderRadius: '6px',
          display: 'inline-block',
          fontSize: '13px',
          fontWeight: 500,
          color: '#ffffffff'
        };

        // Only one license → show styled pill
        if (numbers.length === 1) {
          return <span style={pillStyle}>{numbers[0]}</span>;
        }

        // Multiple license numbers → first license + plus count
        return (
          <>
            <span style={pillStyle}>{numbers[0]}</span>
            <span
              onClick={() => handleShowLicenses(numbers)}
              style={{

                padding: '4px 6px',
                borderRadius: '6px',
                marginLeft: '6px',
                cursor: 'pointer',
                color: '#4554fa',
                fontSize: '13px',
                fontWeight: 500,
                display: 'inline-flex',
                alignItems: 'center'
              }}
            >
              <PlusOutlined style={{ fontSize: '12px', marginRight: '2px' }} />
              {numbers.length - 1} more
            </span>
          </>
        );
      }
    },

    {
      title: 'Source of Request',
      dataIndex: 'source_of_reg_request',
      key: 'source_of_reg_request',
    },
    {

      title: 'Active Membership Plan',
      dataIndex: 'mm_plan_names',
      key: 'membership_plan',
      render: (plans: string[]) => (
        plans?.length
          ? plans.map((plan, index) => (
            <Tag color="blue" key={index}>{plan}</Tag>
          ))
          : "-"
      ),
    },

    {
      title: 'Plan Start Date',
      dataIndex: 'current_active_plan_details',
      key: 'plan_start_date',
      render: (details: any) =>
        details?.current_plan_start_date
          ? dayjs(details.current_plan_start_date).format("DD MMM YYYY")
          : "-",
    },

    {
      title: 'Plan Expiry Date',
      dataIndex: 'current_active_plan_details',
      key: 'plan_start_date',
      render: (details: any) =>
        details?.current_plan_expiration_date
          ? dayjs(details.current_plan_expiration_date).format("DD MMM YYYY")
          : "-",
    },
    {
      title: 'Plan Duration',
      dataIndex: 'current_active_plan_details',
      key: 'plan_duration',
      render: (details: any) => details?.current_plan_duration ?? "-",
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: any) => (
        <Button
          type="primary"
          size="small"
          icon={<EyeOutlined />}
          style={{ fontSize: 12, height: 28 }}
          onClick={() => handleViewDetails(record)}
          loading={isUserDetailsLoading && loadingUserId === record.id}
        >
          View
        </Button>
      ),
    },

  ];


  const inactiveAccountsColumns = [
    {
      title: 'Display Name',
      dataIndex: 'display_name',
      key: 'display_name',

      render: (_: any, record: any) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Avatar size={32} src={record.profile_pic ?? DEFAULT_PROFILE_IMAGE} alt={record.display_name} />
          <div>
            <div style={{ fontWeight: 500, fontSize: 13 }}>{record.display_name}</div>
          </div>
        </div>
      ),
    },

    {
      title: 'Medical License Number',
      dataIndex: 'license_numbers',
      key: 'license_numbers',
      render: (numbers: string[]) => {

        // Handle no data
        if (!Array.isArray(numbers) || numbers.length === 0) {
          return 'N / A';
        }

        // Style object for license "pill"
        const pillStyle: React.CSSProperties = {
          // backgroundColor: '#f6f6ff',
          padding: '4px 8px',
          borderRadius: '6px',
          display: 'inline-block',
          fontSize: '13px',
          fontWeight: 500,
          color: '#ffffffff'
        };

        // Only one license → show styled pill
        if (numbers.length === 1) {
          return <span style={pillStyle}>{numbers[0]}</span>;
        }

        // Multiple license numbers → first license + plus count
        return (
          <>
            <span style={pillStyle}>{numbers[0]}</span>
            <span
              onClick={() => handleShowLicenses(numbers)}
              style={{
                backgroundColor: '#e9eafe',
                padding: '4px 6px',
                borderRadius: '6px',
                marginLeft: '6px',
                cursor: 'pointer',
                color: '#4554fa',
                fontSize: '13px',
                fontWeight: 500,
                display: 'inline-flex',
                alignItems: 'center'
              }}
            >
              <PlusOutlined style={{ fontSize: '12px', marginRight: '2px' }} />
              {numbers.length - 1} more
            </span>
          </>
        );
      }
    },

    {

      title: 'Membership Plan',
      dataIndex: 'mm_plan_names',
      key: 'membership_plan',
      render: (plans: string[]) => (
        plans?.length
          ? plans.map((plan, index) => (
            <Tag color="blue" key={index}>{plan}</Tag>
          ))
          : "-"
      ),
    },

    {
      title: 'Plan Start Date',
      dataIndex: 'current_active_plan_details',
      key: 'plan_start_date',
      render: (details: any) =>
        details?.current_plan_start_date
          ? dayjs(details.current_plan_start_date).format("DD MMM YYYY")
          : "-",
    },

    {
      title: 'Plan Expiry Date',
      dataIndex: 'current_active_plan_details',
      key: 'plan_start_date',
      render: (details: any) =>
        details?.current_plan_expiration_date
          ? dayjs(details.current_plan_expiration_date).format("DD MMM YYYY")
          : "-",
    },

    {
      title: 'Time Since Expiration',
      dataIndex: 'current_active_plan_details',
      key: 'time_since_expiration',
      render: (details: any) =>
        details?.time_since_expiration
          ? `${details.time_since_expiration} days`
          : "0 days",
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: any) => (
        <Button
          type="primary"
          size="small"
          icon={<EyeOutlined />}
          style={{ fontSize: 12, height: 28 }}
          onClick={() => handleViewDetails(record)}
          loading={isUserDetailsLoading && loadingUserId === record.id}
        >
          View
        </Button>
      ),
    },
  ];

  const deletedAccountsColumns = [
    {
      title: 'Display Name',
      dataIndex: 'display_name',
      key: 'display_name',

      render: (_: any, record: any) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Avatar size={32} src={record.profile_pic ?? DEFAULT_PROFILE_IMAGE} alt={record.display_name} />
          <div>
            <div style={{ fontWeight: 500, fontSize: 13 }}>{record.display_name}</div>
          </div>
        </div>
      ),
    },

    {

      title: 'Medical License Number',
      dataIndex: 'license_numbers',
      key: 'license_numbers',
      render: (numbers: string[]) => {

        // Handle no data
        if (!Array.isArray(numbers) || numbers.length === 0) {
          return '-';
        }

        // Style object for license "pill"
        const pillStyle: React.CSSProperties = {

          padding: '4px 8px',
          borderRadius: '6px',
          display: 'inline-block',
          fontSize: '13px',
          fontWeight: 500,
          color: '#ffffffff'
        };

        // Only one license → show styled pill
        if (numbers.length === 1) {
          return <span style={pillStyle}>{numbers[0]}</span>;
        }

        // Multiple license numbers → first license + plus count
        return (
          <>
            <span style={pillStyle}>{numbers[0]}</span>
            <span
              onClick={() => handleShowLicenses(numbers)}
              style={{
                padding: '4px 6px',
                borderRadius: '6px',
                marginLeft: '6px',
                cursor: 'pointer',
                color: '#4554fa',
                fontSize: '13px',
                fontWeight: 500,
                display: 'inline-flex',
                alignItems: 'center'
              }}
            >
              <PlusOutlined style={{ fontSize: '12px', marginRight: '2px' }} />
              {numbers.length - 1} more
            </span>
          </>
        );
      }
    },

    {
      title: 'Source of Request',
      dataIndex: 'source_of_reg_request',
      key: 'source_of_reg_request',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: any) => (
        <Button
          type="primary"
          size="small"
          icon={<EyeOutlined />}
          style={{ fontSize: 12, height: 28 }}
          onClick={() => handleViewDetails(record)}
          loading={isUserDetailsLoading && loadingUserId === record.id}
        >
          View
        </Button>
      ),
    },
  ];

  const renderTableContent = () => {

    let columnsToRender;

    if (activeTab === 'active') {
      columnsToRender = activeAccountsColumns;
    } else if (activeTab === 'inactive') {
      columnsToRender = inactiveAccountsColumns;
    } else if (activeTab === 'deleted') {
      columnsToRender = deletedAccountsColumns;
    }
    return (
      <div>
        <Table
         rowSelection={activeTab === "deleted" ? undefined : rowSelection} 
          columns={columnsToRender}
          dataSource={updatedData || []}
          pagination={{
            position: ["bottomRight"],
            // Must match ITEMS_PER_PAGE in the superadmin API (20): the server
            // returns 20 rows per page, and a smaller pageSize made AntD slice
            // them again client-side, hiding 5 rows of every page.
            pageSize: 20,
            current: pageNumber,
            onChange: (page) => handlePageChange(page),
            total: totalCount,
            showSizeChanger: false,
            showQuickJumper: true,
            showTotal: (total, range) => (
              <div className="pagniation-text">
                {`${range[0]}-${range[1]} of ${total} items`}
              </div>
            ),
          }}
          rowKey="id"
          size="small"
          style={{ fontSize: 13 }}
        />
      </div>
    );
  };

  const tabItems = TABS.map(tab => ({
    label: tab.label,
    key: tab.key,
    children: isLoading ? (
      <div style={{ padding: '20px' }}>
        <Skeleton active paragraph={{ rows: 8 }} />
      </div>
    ) : (
      renderTableContent()
    ),
  }));

  return (
    <div className="request-lists-container">

      <Row className="button-container" gutter={[16, 16]} align="middle" justify="space-between">
        {/* Left section: Search */}
        <Col xs={24} sm={24} md={12}>
          <Row gutter={8} align="middle">
            <Col flex="auto">
              <span className="search-bar">
                <Input
                  placeholder="Search"
                  prefix={<LiaSearchSolid className="search-bar-icon" />}
                  onChange={(e) => setSearchquery(e.target.value)}
                />
              </span>
            </Col>
            <Col>
              <SimpleButton
                text="Search"
                color="primary"
                icon={<SearchOutlined />}
                onClick={handleSearch}
              />
            </Col>
          </Row>
        </Col>
      </Row>


      <Modal
        title="Medical License Number"
        open={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
        bodyStyle={{
          backgroundColor: "#21262c", // dark background
          padding: "16px",
          maxHeight: "400px",
          overflowY: "auto"
        }}
        style={{
          top: 20
        }}
      >
        {licenseNumbers.length > 0 ? (
          <List
            dataSource={licenseNumbers}
            renderItem={(item) => (
              <List.Item
                style={{
                  backgroundColor: "#11161c",
                  color: "#fff",
                  marginBottom: "8px",
                  borderRadius: "6px",
                  padding: "10px 12px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <span>{item}</span>

              </List.Item>
            )}
          />
        ) : (
          <p style={{ color: "#c7cace" }}>No license numbers available.</p>
        )}
      </Modal>
      <ActiveListAction
        selectedRows={selectedRows}
        // fetchUsersListData={updatedData}
        activeTab={activeTab}
        // selectedAlphabet={selectedAlphabet}
        onSpecialityChange={handleSpecialityChange}
        onSiteChange={handleSiteChange}
        onActiveChange={handleActiveChange}
        onClearAll={handleClearAll}
        onRoleChange={handleRoleChange}
        setUseSelectedRows={setSelectedRows}
        resetTableSelection={resetTableSelection}
        selectedSpeciality={undefined}
        roleCheckedList={undefined}
        onFilterResults={(filtered) => setUpdatedData(filtered)} // <-- here
      />
      <Tabs
        items={tabItems}
        defaultActiveKey="active"
        activeKey={activeTab}
        onChange={handleTabChange}
        className="request-lists-tabs"
        tabBarExtraContent={
          activeTab !== "deleted" ?
            <div className="register-user-btn-wrapper" style={{ display: "flex", gap: "8px" }}>
              <SimpleButton  opacity={selectedRowIds?.length === 0? 0.5:1} disabled={selectedRowIds?.length === 0}
                text="Delete "
                color="danger-default"
                onClick={handleDeleteUser}
              />
            </div>
            : null
        }
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          margin: "10px 0",
        }}
      >

      </div>

      <UserDetailsModal
        fromMemberPage={true}
        isVisible={isUserDetailModalVisible && userDetailsData}
        // user={selectedUser}
        user={userDetailsData}
        onClose={handleModalClose}
        onAccept={() => { }}
        onReject={() => { }}
        currentTab={activeTab}
        onEdit={handleEditUserRequest}
        onDelete={() => { }}
        onVerifyLicense={() => { }}
        onRejectLicense={() => { }}
        onEditLicense={() => { }}
        onSaveLicense={() => { }}

      />

    </div>
  );
}
